module.exports = __webpack_public_path__ + "img/pukecast.278c91b6.png";